import { createContext, useState } from "react";

export const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [mathMode, setMathMode] = useState(() => {
    const saved = localStorage.getItem("mathMode");
    return saved ? JSON.parse(saved) : false;
  });

  const [transitioning, setTransitioning] = useState(false);

  const updateMathMode = (value) => {
    setMathMode(value);
    localStorage.setItem("mathMode", JSON.stringify(value));
  };

  return (
    <ThemeContext.Provider
      value={{
        mathMode,
        setMathMode: updateMathMode,
        transitioning,
        setTransitioning,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
}